import { render, staticRenderFns } from "./CostItemContainerStages.vue?vue&type=template&id=948820b8&scoped=true&"
import script from "./CostItemContainerStages.vue?vue&type=script&lang=js&"
export * from "./CostItemContainerStages.vue?vue&type=script&lang=js&"
import style0 from "./CostItemContainerStages.vue?vue&type=style&index=0&id=948820b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948820b8",
  null
  
)

export default component.exports